import React, { FC } from "react";
import { NullSpecsProps } from "./NullSpecsContainer.types";
import { DashboardContainer, ContainerContent, DashboardContainerHeader, DashboardContainerBody, H3 } from "../MoaDashboard.styles";
import EventCount from "../EventCount";

const NullSpecs: FC<NullSpecsProps> = (
    {
      nullSpecMetrics,
      setOpenDrawer,
      setDrawerType,
      isLoading,
      setFetchNullSpecs,
      setDrawerColumnDefs
    }
) => {

  const nullSpecsColumnDefs = [
    {
      minWidth: 100, field: 'storeNo', headerName: 'Store #', sortable: true, floatingFilter: false
    },
    {
      minWidth: 200, field: 'marketNo', headerName: 'FZ Code', sortable: false, floatingFilter: false
    }
  ];
  
  const openMissingSpecsDrawer = () => {
    setFetchNullSpecs(true);
    setDrawerType('nullSpecs');
    setDrawerColumnDefs(nullSpecsColumnDefs);
    setOpenDrawer(true);
  }

  return (
      <DashboardContainer style={{ width: '85%' }} data-testid={'missingSpecsContainer'}>
        <DashboardContainerHeader data-testid="nullSpecsContainerHeader">
          Missing Specs
        </DashboardContainerHeader>
        <DashboardContainerBody>
          <ContainerContent style={{ position: 'relative', flexGrow: '3', justifyContent: 'space-between' }}>
            <EventCount
                label={'Menus'}
                count={nullSpecMetrics?.menus}
                isLoading={isLoading}
            />
            {!isLoading && nullSpecMetrics?.menus !== 0 &&
              <H3
                label={'See details'}
                onClick={openMissingSpecsDrawer}
                style={{ paddingRight: '1rem' }}
                dataTestId="seeNullSpecsDetails" 
                to={''}
              />
            }
          </ContainerContent>
        </DashboardContainerBody>
      </DashboardContainer>
  );
}

export default NullSpecs;